import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { View } from 'react-native';
import { Input, InView } from '@airtel/air-design-system';
import { getFormFieldComponentStyles } from './FormFieldStyles';
import ValidationRule from '../validation-rule/ValidationRule';
var FormField = _ref => {
  var fieldName = _ref.fieldName,
    field = _ref.field,
    onUserAction = _ref.onUserAction,
    index = _ref.index,
    validateInputText = _ref.validateInputText,
    onAppendItemPressHandler = _ref.onAppendItemPressHandler;
  var id = field.id,
    onItemVisibleMetaData = field.onItemVisibleMetaData,
    inputFieldProps = field.inputFieldProps,
    iconSize = field.iconSize,
    onFieldValueChangeMetaData = field.onFieldValueChangeMetaData,
    validationRules = field.validationRules,
    _field$showValidation = field.showValidations,
    showValidations = _field$showValidation === void 0 ? true : _field$showValidation,
    formFieldStyle = field.style;
  var formFieldComponentStyles = getFormFieldComponentStyles();
  return _jsx(View, Object.assign({
    style: [formFieldComponentStyles === null || formFieldComponentStyles === void 0 ? void 0 : formFieldComponentStyles.formFieldWrapper, formFieldStyle]
  }, {
    children: _jsxs(InView, Object.assign({
      triggerOnce: true,
      onChange: inView => {
        inView && onItemVisibleMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
          id
        }, onItemVisibleMetaData), Object.assign({
          index
        }, field)));
      }
    }, {
      children: [_jsx(Input, Object.assign({}, inputFieldProps, {
        appendItems: Object.assign(Object.assign({}, (inputFieldProps === null || inputFieldProps === void 0 ? void 0 : inputFieldProps.inputFieldState) === 'primary' ? inputFieldProps === null || inputFieldProps === void 0 ? void 0 : inputFieldProps.primaryAppendItems : inputFieldProps === null || inputFieldProps === void 0 ? void 0 : inputFieldProps.secondaryAppendItems), {
          onPress: () => onAppendItemPressHandler(fieldName)
        }),
        secureTextEntry: (inputFieldProps === null || inputFieldProps === void 0 ? void 0 : inputFieldProps.inputFieldState) === 'primary' ? (inputFieldProps === null || inputFieldProps === void 0 ? void 0 : inputFieldProps.primaryInputFieldType) === 'password' : (inputFieldProps === null || inputFieldProps === void 0 ? void 0 : inputFieldProps.secondaryInputFieldType) === 'password',
        onChangeText: value => {
          validateInputText(fieldName, value);
          onFieldValueChangeMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(onFieldValueChangeMetaData, Object.assign({
            value
          }, field)));
        }
      })), showValidations && (validationRules === null || validationRules === void 0 ? void 0 : validationRules.length) > 0 ? validationRules === null || validationRules === void 0 ? void 0 : validationRules.filter(_ref2 => {
        var _ref2$showRule = _ref2.showRule,
          showRule = _ref2$showRule === void 0 ? true : _ref2$showRule;
        return showRule;
      }).map((rule, index) => _jsx(ValidationRule, {
        rule: rule,
        index: index,
        iconSize: iconSize
      })) : null]
    }))
  }));
};
export default FormField;